import { Button } from 'components/Button/Button';
import FlagListingContainer from 'containers/FlagListingContainer';
import { ListingType } from 'types/ListingType';

type Props = {
  listingId: string;
  listingType: ListingType;
};

export function ReportListingMenuItem({ listingId, listingType }: Props) {
  return (
    <FlagListingContainer
      listingId={listingId}
      listingType={listingType}
      render={({ flagListing }) => (
        <Button
          type="button"
          data-qa-id="flag-content"
          onClick={() => {
            flagListing();
          }}
          variant="dropdown"
          iconPosition="left"
          icon={{ type: 'normalized', name: 'flag' }}
          size="small"
        >
          {getText('Report This Listing')}
        </Button>
      )}
    />
  );
}
